"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = exports.getCashbotItemAttrs = exports.getCashbotButtonAttrs = exports.getCashbotAttrs = exports.focusHandler = exports.isDesktop = void 0;

var _this = void 0,
    _arguments = arguments;

var hasBootstrapData = function hasBootstrapData() {
  return !!window.BOOTSTRAP_DATA;
};

var isDesktop = function isDesktop() {
  if (hasBootstrapData()) {
    return window.BOOTSTRAP_DATA.isDesktop;
  }

  return false;
};

exports.isDesktop = isDesktop;

var focusHandler = function focusHandler(ref, doFocus) {
  if (isDesktop() && ref && doFocus) {
    ref.focus();
  }
};
/**
 * Generate the cashbot-data attribute.
 *
 * Usually this is used to identified collection of elements in a field-group
 * (e.g. input, error message, help, etc).
 *
 * @param {string} inputName - The name of the input element.
 * @param {string} cashbotName - The prefix for the attribute's value.
 *                               It is important choose a name that is unique in the rendered html.
 * @param {Object} [options={}] - (optional) Optional additional attributes to include:
 *      maxLength: the maxLength value expected for the input
 * @returns {Object}
 */


exports.focusHandler = focusHandler;

var getCashbotAttrs = function getCashbotAttrs(inputName, cashbotName) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cashbotAttrs = {
    'data-cashbot-id': "".concat(cashbotName, "-").concat(inputName)
  };

  if (options.maxLength) {
    cashbotAttrs['data-cashbot-maxlength'] = options.maxLength;
  }

  return cashbotAttrs;
};
/**
 * Generate the cashbot-button attribute.
 * This is used to identified a button (e.g. Add Another Card).
 *
 * @param {string} cashbotName - The prefix for the attribute's value.
 * @param {string} type - The type of the button
 * @returns {Object}
 */


exports.getCashbotAttrs = getCashbotAttrs;

var getCashbotButtonAttrs = function getCashbotButtonAttrs(cashbotName, type) {
  return {
    'data-cashbot-id': "".concat(cashbotName, "-button-").concat(type)
  };
};
/**
 * Generate the cashbot-item attribute.
 *
 * This should be used when wrapping the value from a field so that it can be
 * identified.
 *
 * @param {string} cashbotName - The prefix for the attribute's value.  Usually this should be the form or step.  It is important
 * @param {string} attrName - The name of the field
 * @returns {Object}
 */


exports.getCashbotButtonAttrs = getCashbotButtonAttrs;

var getCashbotItemAttrs = function getCashbotItemAttrs(cashbotName, attrName) {
  return {
    'data-cashbot-id': "".concat(cashbotName, "-").concat(attrName)
  };
};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear'
 * that is a function which will clear the timer to prevent previously scheduled executions.
 * NOTE: cribbed from https://github.com/component/debounce
 *
 * @param {Function} func - function to wrap
 * @param {Number} [wait=100] - timeout in ms (`100`)
 * @param {Boolean} [immediate=false] - whether to execute at the beginning
 */


exports.getCashbotItemAttrs = getCashbotItemAttrs;

var debounce = function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var timeout;
  var args;
  var context;
  var timestamp;
  var result;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;

      if (!immediate) {
        result = func.apply(context, args);
        context = null;
        args = null;
      }
    }
  }

  var debounced = function debounced() {
    context = _this;
    args = _arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };

  debounced.clear = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  debounced.flush = function () {
    if (timeout) {
      result = func.apply(context, args);
      context = null;
      args = null;
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

exports.debounce = debounce;